import Model from 'cdna/core/model';
import VideoGroupCollection from './videoGroupCollection.js';

export default Model.extend({
    defaults: {
        Title: 'Videos & Documentation',
        Groups: [],
        isActive: false,
        canPrint: false
    },
    modelTypes: {
        Groups: VideoGroupCollection
    },
    getVideoById(videoId) {
        return this.get('Groups').chain()
            .map(function(group) {
                return group.get('Videos').get(videoId);
            })
            .filter(function(video) {
                return !!video;
            })
            .first()
            .value();
    }
});



/** WEBPACK FOOTER **
 ** ./client/video/videoPageModel.js
 **/